// extracted by mini-css-extract-plugin
module.exports = {"top":"_6c97079b1b--top--2CN5W","close":"_6c97079b1b--close--282P3"};